newInternalState